import type { Uuid } from '@sibe/utilities/common';
import type { HsBox } from '../../math-new/shapes/box.class';
import type { HsSphere } from '../../math-new/shapes/sphere.class';
import type { HsGraphicsBuffer } from '../../graphic-render-new/types/graphic-buffer.type';
import type { HsGeometryType } from './geometry-type.enum';
import type { HsGeometry } from './geometry.interface';

export class HsIndexedGeometry implements HsGeometry {
  public isDeleted: boolean = false;
  public batchingIndices?: Uint32Array;

  constructor(
    public readonly uuid: Uuid,
    public readonly geometryType: HsGeometryType,
    public readonly boundingBox: HsBox,
    public readonly boundingSphere: HsSphere,
    public readonly positionArrayLength: number,
    public readonly indexArrayLength: number,
    public readonly buffer: HsGraphicsBuffer,
    public readonly indexBuffer: HsGraphicsBuffer
  ) {}
}
